import { render } from "./PlayerMkv.vue?vue&type=template&id=320b615a&scoped=true"
import script from "./PlayerMkv.vue?vue&type=script&lang=js"
export * from "./PlayerMkv.vue?vue&type=script&lang=js"

import "./PlayerMkv.vue?vue&type=style&index=0&id=320b615a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320b615a"]])

export default __exports__